import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";

import toast from "react-hot-toast";
import authService from "../../services/authService";

import styles from "./loginOtp.module.css";

import { useState } from "react";

export default function LoginOtp({ onClose }) {
  const navigate = useNavigate();

  const [sending, setSending] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      login: "",
    },
  });

  const onSubmit = async ({ login }) => {
    try {
      setSending(true);

      const res = await authService.sendLoginOtp(login);

      if (res?.data?.user?.user_role === "admin") {
        toast.error(
          "Admin not allowed to login with OTP. Please use Admin Login."
        );

        return;
      }

      toast.success("OTP sent successfully");

      // Close Login OTP popup
      if (onClose) {
        onClose();
      }

      // IMPORTANT:
      // Open Verify OTP popup on Home page
      setTimeout(() => {
        window.dispatchEvent(
          new CustomEvent("open-login-otp-verify", {
            detail: {
              login,
            },
          })
        );
      }, 0);
    } catch (err) {
      const message = err?.response?.data?.message;

      if (message === "ADMIN_LOGIN_NOT_ALLOWED") {
        toast.error(
          "Admin not allowed to login with OTP. Please use Admin Login."
        );
      } else {
        toast.error(message || "Failed to send OTP");
      }
    } finally {
      setSending(false);
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate("/");
    }
  };

  // Password Login
  const handlePasswordLogin = () => {
    // Close OTP popup
    if (onClose) {
      onClose();
    }

    // Open password popup
    setTimeout(() => {
      window.dispatchEvent(
        new CustomEvent("open-login-password")
      );
    }, 0);
  };

  return (
    <div
      className={styles.overlay}
      onClick={handleClose}
    >
      <div
        className={styles.modal}
        onClick={(e) => e.stopPropagation()}
      >
        {/* CLOSE BUTTON */}

        <button
          type="button"
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>

        {/* LOGO */}

        <div className={styles.logo}>
          <Link to="/">
            <img
              src="/vitauralogo.jpg"
              alt="Vitaura Logo"
              className={styles.logoImage}
            />
          </Link>
        </div>

        {/* TITLE */}

        <h4 className={styles.title}>
          Login or Signup
        </h4>

        <p className={styles.subtitle}>
          Enter email or phone number
        </p>

        {/* FORM */}

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={styles.inputGroup}>
            <input
              className={styles.input}
              placeholder="Email or Phone Number"
              {...register("login", {
                required:
                  "Email or phone number is required",

                validate: (value) => {
                  const input = value.trim();

                  // PHONE
                  if (/^\d+$/.test(input)) {
                    return (
                      /^\d{10}$/.test(input) ||
                      "Phone number must be exactly 10 digits"
                    );
                  }

                  // EMAIL
                  return (
                    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                      input
                    ) ||
                    "Please enter a valid email address"
                  );
                },
              })}
            />

            {errors.login && (
              <p className={styles.error}>
                {errors.login.message}
              </p>
            )}
          </div>

          {/* SEND OTP */}

          <button
            type="submit"
            className={styles.button}
            disabled={sending}
          >
            {sending
              ? "Sending OTP..."
              : "Send OTP"}
          </button>
        </form>

        {/* PASSWORD LOGIN */}

        {/* <div className={styles.textCenter}>
          <button
            type="button"
            className={styles.link}
            onClick={handlePasswordLogin}
          >
            Password Based Login
          </button>
        </div> */}
      </div>
    </div>
  );
}